"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _createSvgIcon = _interopRequireDefault(require("./utils/createSvgIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/* eslint-disable */
var _default = (0, _createSvgIcon["default"])( /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("rect", {
  width: "4.8",
  height: "14.4",
  x: "19.2",
  y: "9.6001",
  rx: "2",
  transform: "rotate(90 19.2 9.6001)"
})), 'DndIcon');
/* eslint-enable */


exports["default"] = _default;